// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2l0Tp","search":"Settings_search__2RjQk","filter":"Settings_filter__2rfWS"};